let instance = null;

export default class Singleton {  
  constructor() {
    if (!instance) {
      instance = this;
      this.oAuthToken = null;
      this._company_id = null;
      this.context = null;
    }
    return instance;
  }
  
  get company_id() {
    return this._company_id;
  }
  
  set company_id(value) {
    this._company_id = value;
  }
}